import { render, staticRenderFns } from "./detailSeller.vue?vue&type=template&id=65a0c4c3&scoped=true&"
import script from "./detailSeller.js?vue&type=script&lang=js&"
export * from "./detailSeller.js?vue&type=script&lang=js&"
import style0 from "./detailSeller.vue?vue&type=style&index=0&id=65a0c4c3&lang=scss&scoped=true&"
import style1 from "./detailSeller.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a0c4c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65a0c4c3')) {
      api.createRecord('65a0c4c3', component.options)
    } else {
      api.reload('65a0c4c3', component.options)
    }
    module.hot.accept("./detailSeller.vue?vue&type=template&id=65a0c4c3&scoped=true&", function () {
      api.rerender('65a0c4c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/detail/detailSeller.vue"
export default component.exports